module.exports = __webpack_public_path__ + "img/mysqllogo.435cb638.png";